import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import OTTLogo from '@ott/icon-ott-logo';

import styles from './OTTLogoWithText.scss';

const OTTLogoWithText = React.memo(function OTTLogoWithText({
  to,
  isInternal,
  project,
  iconWidth,
  ...restProps
}) {
  if (isInternal) {
    return (
      <Link className={styles.OTTLogoWithText} to={to} {...restProps}>
        <OTTLogo project={project} w={iconWidth} className={styles.logoImage} />
      </Link>
    );
  } else {
    return (
      <a className={styles.OTTLogoWithText} href={to} {...restProps}>
        <OTTLogo project={project} w={iconWidth} className={styles.logoImage} />
      </a>
    );
  }
});

OTTLogoWithText.propTypes = {
  to: PropTypes.string,
  project: PropTypes.string,
  isInternal: PropTypes.bool,
  iconWidth: PropTypes.number,
};

OTTLogoWithText.defaultProps = {
  to: '/',
  iconWidth: 48,
};

export default OTTLogoWithText;
